import { useQuery } from '@tanstack/react-query';
import { LearnableDetailsApi } from 'src/api';
import { LearnableDetails } from 'src/api/learnableDetails/types';

export const useLearnableMedia = (
  learnableId: number,
  { enabled = true }: { enabled?: boolean } = {},
): { videoUrls: string[]; audioUrls: string[]; isPending: boolean } => {
  const { data, isPending } = useQuery<LearnableDetails | null>({
    queryKey: ['learnableDetails', learnableId],
    queryFn: () => LearnableDetailsApi.getLearnableDetails(learnableId),
    enabled,
  });

  return {
    videoUrls: data?.videoUrls ?? [],
    audioUrls: data?.audioUrls ?? [],
    // Callers that fall back when a word has no video need to tell "no clips"
    // apart from "clips not fetched yet".
    isPending: enabled && isPending,
  };
};
